import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import "../../assets/css/pages/customers.css";
import axios from "axios";
import swal from 'sweetalert';
import _ from "lodash";
import avatarBlank from "../../assets/media/svg/avatar-blank.svg";
import {downloadBlob} from "../../Components/Helpers/Utils";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const user = useSelector(state => state.user);
  const isAdmin = user?.isAdminType;
  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;

  useEffect(() => {
    $('#customers thead tr')
      .clone(true)
      .addClass('filters display-none')
      .appendTo('#customers thead');

    let table = $('#customers').DataTable({
      "ajax": {
        url: process.env.REACT_APP_API_URL + "customers",
        method: 'GET',
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      initComplete: function () {
        var api = this.api();

        // For each column
        api
          .columns()
          .eq(0)
          .each(function (colIdx) {
            // Set the header cell to contain the input element
            var cell = $('.filters th').eq(
              $(api.column(colIdx).header()).index()
            );
            var title = $(cell).text();
            $(cell).html('<input type="text" placeholder="' + title + '" />');

            // On every keypress in this input
            $(
              'input',
              $('.filters th').eq($(api.column(colIdx).header()).index())
            )
              .off('keyup change')
              .on('keyup change', function (e) {
                e.stopPropagation();

                // Get the search value
                $(this).attr('title', $(this).val());
                var regexr = '({search})'; //$(this).parents('th').find('select').val();

                var cursorPosition = this.selectionStart;
                // Search the column for that value
                api
                  .column(colIdx)
                  .search(
                    this.value != ''
                      ? regexr.replace('{search}', '(((' + this.value + ')))')
                      : '',
                    this.value != '',
                    this.value == ''
                  )
                  .draw(false);

                $(this)
                  .focus()[0]
                  .setSelectionRange(cursorPosition, cursorPosition);
              });
          });
      },
      "destroy": true,
      "columns": [
        {
          data: 'actions',
          searchable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"><span></span></span>
                    </label>
                    `;
          },
        },
        {data: 'id', name: 'id'},
        {
          data: 'avatar',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            const img = row?.image?.url || avatarBlank;

            return `<div class="image" row-id="${row.id}" style="background: url(${img});" title="Show Customer"></div>
                    <div class="customer-status" title="${row.is_active ? "Active" : "Blocked"}">
                      <span class="${row.is_active ? "bg-success" : "bg-danger"}"></span>
                    </div>
                    `;
          },
        },
        {data: 'email', name: 'email'},
        {data: 'first_name', name: 'first_name'},
        {data: 'last_name', name: 'last_name'},
        {
          data: 'created_at',
          searchable: false,
          orderable: true,
          render: function (data, type, row) {
            return new Date(row?.created_at).toLocaleDateString('en-GB');
          },
        },
        {data: 'phone', name: 'phone'},
        {data: 'personal_number', name: 'personal_number'},
        {data: 'identification_code', name: 'identification_code'},
        {
          data: 'marketing_status', 
          name: 'marketing_status',
          render: function (data, type, row) {
            // Check if marketing_status is 1
            return Number(row.marketing_status) === 1 ? '<span class="marketing-status-yes">Yes</span>' : '<span class="marketing-status-no">No</span>';
          },
        },
        {
          data: 'agreement', 
          name: 'marketing_status',
          render: function (data, type, row) {
            // Check the value of agreement and return appropriate HTML
            return Number(row.agreement) === 1
              ? '<span class="marketing-status-yes">Yes</span>'
              : Number(row.agreement) === 2
              ? '<span class="marketing-status-no">No</span>'
              : '<span class="marketing-status-no-answer">No Answer</span>';
          },
        },
        {
          data: 'actions',
          searchable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 show"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-eye"></i> Show
                            </button>
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                            <button 
                            class="btn btn-${row.is_active ? "danger" : "success"} me-2 mt-1 status"
                            row-id="${row.id}" row-name="${row.first_name}" row-email="${row.email}" row-status="${row.is_active ? "active" : "blocked"}">
                                <i class="fas fa-${row.is_active ? "lock" : "unlock"}"></i> ${row.is_active ? "Block" : "Unblock"}
                            </button>
                        <div>
                    </div>
                    `;
          },
        }
      ],
      "columnDefs": [{
        "targets": [0, 6, 7, 8, 9, 10],
        "orderable": false
      }],
      "order": [[0, "desc"]],
    });

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });

    table.on('click', 'button.show, div.image', function () {
      const id = ($(this).attr("row-id"));
      navigate(`/customers/${id}`)
    });

    table.on('click', 'button.edit', function () {
      const id = ($(this).attr("row-id"));
      navigate('/customers/' + id + '/edit');
    });

    table.on('click', 'button.status', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      const email = ($(this).attr("row-email"));
      const status = ($(this).attr("row-status"));
      toggleActiveStatus(id, name, email, status, table);
    });

    $("<span class='table-filter-icon' title='Filter'><i class='fa fa-filter fs-4 br-1000'></i>Filter</span>")
      .insertAfter("#customers_length label");
    $(".table-filter-icon").click(function () {
      $("#customers thead .filters").toggle();

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");


    table.on('click', '.form-label-checkbox .checkbox.list', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });

    $("table.dataTable thead tr:first-child th:nth-child(1)")
      .html(`<label class="form-label-checkbox fs-6 fw-bolder text-dark pt-0">
           <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
           <span class="checkmark"><span></span></span>
           </label>`);

    $(`.d-flex.flex-stack, #kt_header, #kt_aside, .header-brand, .topbar, table.dataTable tbody, table.dataTable thead tr:first-child,
    .dataTables_wrapper .row:nth-child(3), .dataTables_wrapper .row:nth-child(1) div:nth-child(2)`).click(function () {
      if ($(".table-filter-icon i").hasClass("fa-times-circle")) {
        $("table.dataTable thead .filters").hide();
        $(".table-filter-icon i")
          .removeClass("fa-times-circle")
          .addClass("fa fa-filter")
      }
    });

  }, []);

  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  const addCustomer = () => {
    navigate('/customers/create');
  }

  //Bulk Action Start()
  const bulkBlockUnblockCustomers = (unblock) => {
    swal({
      title: "Are you sure?",
      text: `You want to ${unblock ? "unblock" : "block"} marked customers?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      console.log(result);
      if (result == true) {
        axios.post('bulk-customer-status', {
          customers: bulkArray,
          value: unblock,
        })
          .then(function (res) {
            if (res.status == 200) {
              swal(`Cusomers has been ${unblock ? "unblocked" : "blocked"} successfully!`, {
                icon: "success",
              });
              $('#customers').DataTable().draw(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data.errors);
            }
          });
      }
    });
  }
  //Bulk Action End()

  const toggleActiveStatus = (id, name, email, status, table) => {
    swal({
      title: "Are you sure?",
      text: `You want to ${status == "active" ? "block" : "unblock"} customer "${name !== 'null' ? name : email}"`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      console.log(result);
      if (result == true) {
        axios.get('customer-is-active-toggle/' + id)
          .then((res) => {
            if (res.status == 200) {
              swal(`Customer "${name !== 'null' ? name : email}" has been ${status == "active" ? "blocked" : "unblocked"}!`, {
                icon: "success",
              });
              table.draw(false);
              return true;
            } else {
              return false;
            }
          }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  const exportCustomers = () => {
    axios.get('exports/customers', {
      responseType: 'blob',
    }).then(res => {
      downloadBlob(res.data, 'customers.xlsx');
    });
  }

  return (
    <>
      <div>
        <div className="d-flex flex-stack pb-5">
          {isAdmin &&
            <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
              <button type="button"
                      className="btn btn-primary mr-3"
                      data-bs-toggle="tooltip"
                      title="Coming Soon"
                      onClick={addCustomer}
              >
                <i className="fas fa-plus-circle fs-4 mr-2"></i>
                Add Customer
              </button>
              <button type="button"
                      className="btn btn-primary"
                      data-bs-toggle="tooltip"
                      title="Export"
                      onClick={exportCustomers}
              >
                <i className="fa fa-download"></i>
                Export
              </button>
            </div>
          }
          <div className={`marked-actions${buttonIsDisabled ? " d-none" : ""}`}>
            <button
              type="button"
              className="btn btn-success mr-3"
              onClick={() => bulkBlockUnblockCustomers(true)}
              disabled={buttonIsDisabled}
            >
              <i className="fas fa-lock-open mr-2"></i>
              Unblock
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => bulkBlockUnblockCustomers(false)}
              disabled={buttonIsDisabled}
            >
              <i className="fas fa-lock mr-2"></i>
              Block
            </button>
          </div>
        </div>
        <table id="customers" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th></th>
            <th>ID</th>
            <th>Avatar</th>
            <th>Email</th>
            <th>First name</th>
            <th>Last name</th>
            <th>Created Date</th>
            <th>Phone</th>
            <th>Personal Number</th>
            <th>Identification Code</th>
            <th>Marketing Status</th>
            <th>Ageement</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold">
          </tbody>
        </table>
      </div>
    </>
  );
}